import { render, staticRenderFns } from "./FooterMain.vue?vue&type=template&id=2b4ab716&scoped=true&"
import script from "./FooterMain.vue?vue&type=script&scope=true&lang=js&"
export * from "./FooterMain.vue?vue&type=script&scope=true&lang=js&"
import style0 from "./FooterMain.vue?vue&type=style&index=0&id=2b4ab716&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4ab716",
  null
  
)

export default component.exports